import { Form, Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Button, InputGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'

import './FormInput.css'

const autoFillPreview = (preview) => {
  return (
      <Tooltip className='preview-popup'>
          {preview}
      </Tooltip>
  )
}

export function TextInput({ inputLabel, inputName, inputValue, inputRequired, inputInfo, changeFunc, placeholder, asterisk=false, autoFillInfo=null}) {
  return (
    <Form.Group as={Row} className="mb-3 align-items-center text-start">
        <Form.Label column xs={3} className="formInput">{inputLabel}<span style={{color: "red", fontWeight: "bold", fontSize: 20, display: (asterisk ? "inline" : "none")}}>*</span></Form.Label>
        {(!inputInfo)
        ? (!autoFillInfo ?
        <Col xs={7}>
            <Form.Control name={inputName} value={inputValue} required={inputRequired} onChange={changeFunc} placeholder={placeholder}/>
        </Col>
        :
        <Col xs={7}>
          <InputGroup>
          <Form.Control name={inputName} value={inputValue} required={inputRequired} onChange={changeFunc} placeholder={placeholder}/>
          <OverlayTrigger
            placement='top'
            overlay={autoFillPreview(autoFillInfo.value)}>
            <Button type="button"
              style={{backgroundColor: "#a73c21", borderColor: "#a73c21",}}
              onClick={autoFillInfo.fill}>Autofill</Button>
          </OverlayTrigger>
          </InputGroup>
            
        </Col>
        )
        : (!autoFillInfo ?
        <Col xs={7} className="d-flex">
            <Col xs={7}>
              <Form.Control name={inputName} value={inputValue} required={inputRequired} onChange={changeFunc} placeholder={placeholder}/>
            </Col>
            <Form.Label column xs={7} className="formInput">{inputInfo}</Form.Label>
        </Col>
        :
        <Col xs={7} className="d-flex">
            <Col xs={7}>
              <InputGroup>
              <Form.Control name={inputName} value={inputValue} required={inputRequired} onChange={changeFunc} placeholder={placeholder}/>
              <OverlayTrigger
                placement='top'
                overlay={autoFillPreview(autoFillInfo.value)}>
                <Button type="button"
                  style={{backgroundColor: "#a73c21",}}
                  onClick={autoFillInfo.fill}>Autofill</Button>
              </OverlayTrigger>
              </InputGroup>
            </Col>
            <Form.Label column xs={7} className="formInput">{inputInfo}</Form.Label>
        </Col>
        )
        }
    </Form.Group>
  )
}

export function SelectInput({ inputLabel, inputName, inputValue, selectOptions, changeFunc }) {
  return (
    <Form.Group as={Row} className="mb-3">
      <Form.Label column xs={3} className="formInput">{inputLabel}</Form.Label>
      <Col xs={5}>
          <Form.Select name={inputName} value={inputValue} onChange={changeFunc}>
              <option value='' key={''}></option>
              {selectOptions.map((selectOption, x) =>
                <option value={selectOption.name} key={x}>{selectOption.name}</option>
              )}
          </Form.Select>
      </Col>
    </Form.Group>
  )
}

export function BrandSelectInput({ inputLabel, inputName, inputValue, selectOptions, changeFunc, autoFillInfo }) {
  return (
    <Form.Group as={Row} className="mb-3">
      <Form.Label column xs={3} className="formInput">{inputLabel}</Form.Label>
      <Col xs={5}>
        {(!autoFillInfo
        ?
          <Form.Select name={inputName} value={inputValue} onChange={changeFunc}>
              <option value={0} key={''}></option>
              {selectOptions.map((selectOption, x) =>
                <option value={selectOption.id} key={x}>{selectOption.name}</option>
              )}
          </Form.Select>
        :
          <InputGroup>
          <Form.Select name={inputName} value={inputValue} onChange={changeFunc}>
                <option value={0} key={''}></option>
                {selectOptions.map((selectOption, x) =>
                  <option value={selectOption.id} key={x}>{selectOption.name}</option>
                )}
          </Form.Select>
          <OverlayTrigger
            placement='top'
            overlay={autoFillPreview(autoFillInfo.name)}>
            <Button type="button"
              style={{backgroundColor: "#a73c21", borderColor: "#a73c21",}}
              onClick={autoFillInfo.fill}>Autofill</Button>
          </OverlayTrigger>
          </InputGroup>
        )}
      </Col>
    </Form.Group>
  )
}

export function TextAreaInput({ inputLabel, inputName, inputValue, changeFunc }) {
  return (
    <Form.Group as={Row} className="mb-3">
        <Form.Label column xs={3} className="productFormLabel">{inputLabel}</Form.Label>
        <Col lg={7} xs={7} className="text-start">
            <Form.Control as="textarea" rows={3} name={inputName} value={inputValue} onChange={changeFunc} />
        </Col>
    </Form.Group>
  )
}

export function FormInput({ inputName, inputValue, inputLabel, changeFunc, inputRequired, inputType, selectOptions }) {
  if (inputType === 'text') {
    return (
          <Form.Group as={Row} className="mb-3">
              <Form.Label column xs={4} className="formInput">{inputLabel}</Form.Label>
              <Col lg={7} xs={7}>
                  <Form.Control name={inputName} value={inputValue} required={inputRequired} onChange={changeFunc}/>
              </Col>
          </Form.Group>
    );
  } else if (inputType === 'select') {
    return (
      <Form.Group as={Row} className="mb-3">
          <Form.Label column lg={4} xs={4} className="formInput">{inputLabel}</Form.Label>
          <Col lg={7} xs={7}>
              <Form.Select name={inputName} value={inputValue} onChange={changeFunc}>
                  <option value='' key={''}></option>
                  {selectOptions.map((selectOption) =>
                      <option value={selectOption.name} key={selectOption.name}>{selectOption.name}</option>)}
              </Form.Select>
          </Col>
      </Form.Group>
    )
  } else if (inputType === 'textArea') {
    return (
      <Form.Group as={Row} className="mb-3">
          <Form.Label column lg={4} xs={4} className="productFormLabel">{inputLabel}</Form.Label>
          <Col lg={7} xs={7} className="text-start">
              <Form.Control name={inputName} value={inputValue} as="textarea" rows={3} onChange={changeFunc} />
          </Col>
      </Form.Group>
      )
  }
}
